import { Helpers } from '@bode-canada/core';
import OptionsHelper from '@/utils/OptionsHelper';
import FilterQueryMapper from '../../../features/sold-data/shared/components/base-filter/mappers/QueryMapper';
import SearchQueryMapper from '../../../features/sold-data/shared/components/forms/search/mappers/QueryMapper';
import { SearchAddressControlValueProps } from '../../../features/sold-data/shared/components/forms/search/enums';
import SoldDataState from '../../../features/sold-data/shared/services/SoldDataState';
import { createForm as createFiltersForm } from '../../../features/sold-data/shared/components/base-filter/controls';
import { createSearchForm } from '../../../features/sold-data/shared/components/forms/search/controls';
import ApiQueryMapper from '../mappers/ApiQueryMapper';
import { MIN_ADDRESS_LENGTH } from '../constants';
import SearchOptionsMapper from '../mappers/SearchOptionsMapper';
import FetchSoldData from './FetchSoldData';

// @vue/component
const HandleForms = {
  mixins: [FetchSoldData],
  data() {
    return {
      justLoaded: false,
      filtersForm: createFiltersForm(),
      searchForm: createSearchForm(),
    };
  },
  methods: {
    initSearchForm() {
      const initialSearchFormValue = SearchQueryMapper.mapFromQueries(this.$route.query);
      const searchAddressOptions = initialSearchFormValue.address ? [OptionsHelper.createOption(
        initialSearchFormValue.address[SearchAddressControlValueProps.Address],
        initialSearchFormValue.address,
      )] : [];

      SoldDataState.patch({ searchAddressOptions });
      this.searchForm.setValue(initialSearchFormValue);
    },
    initFilterForm() {
      const initialFiltersFormValue = FilterQueryMapper.mapFromQueries(this.$route.query);

      this.filtersForm.setValue(initialFiltersFormValue);
    },
    handleFiltersSubmit(value) {
      this.searchForm.reset();
      this.loadResultsByFilters(value);
    },
    async handleSearchSubmit(value) {
      this.filtersForm.reset();
      await this.loadResultsBySearch(value);
    },
    handleFiltersChange() {
      this.setRouterQuery();
    },
    handleSearchChange() {
      this.setRouterQuery();
    },
    setRouterQuery() {
      const query = this.cleanupRouterQuery({
        ...SearchQueryMapper.mapToQueries(this.searchForm.value),
        ...FilterQueryMapper.mapToQueries(this.filtersForm.value),
      });

      if (!Helpers.ObjectHelper.isEqual(query, this.$route.query)) {
        this.$router.replace({ query });
      }
    },
    async loadResultsByFilters(value) {
      const requestQuery = ApiQueryMapper.mapFilterToQuery(FilterQueryMapper.mapToQueries(value));

      await this.loadSoldDataBySearchQuery(requestQuery);
    },
    async loadResultsBySearch(value) {
      const requestQuery = ApiQueryMapper.mapSearchToQuery(SearchQueryMapper.mapToQueries(value));

      await this.loadSoldDataBySearchQuery(requestQuery);
    },
    async loadSoldDataBySearchQuery(requestQuery) {
      this.resetSoldData();
      await this.loadSoldData(requestQuery);
      this.handleListingsLoad();
      this.justContentLoaded = true;

      if (this.listings.length) {
        this.scrollToListingMap();
      }
    },
    async loadSearchOptions(searchValue) {
      if (searchValue?.length < MIN_ADDRESS_LENGTH) {
        return [];
      }

      const requestQuery = ApiQueryMapper.mapSearchStringToQuery(searchValue);
      const { data = [] } = await this.fetchSoldData(requestQuery);

      return SearchOptionsMapper.mapListingsIntoOptions(data);
    },
    cleanupRouterQuery(query) {
      return Object.fromEntries(
        Object.entries(query).map(([key, value]) => ([key, value.toString()])),
      );
    },
  },
};

export default HandleForms;
